export const validation = {
  blocks: {
    min: 1,
    max: 12
  },
  headingMaxChar: 200,
  blockTitleMaxChar: 100,
  blockParagraphMaxChar: 300
}
